// @systeme: interface
// Les rayons du magasin, en clair, dans l'ordre du parcours (le serveur trie ; ici on nomme).
import type { Rayon } from '@foyer/shared';

export const NOMS_RAYONS: Record<Rayon, string> = {
  fruits_legumes: 'Fruits et légumes',
  boulangerie: 'Boulangerie',
  viande_poisson: 'Viande et poisson',
  cremerie: 'Crèmerie',
  epicerie: 'Épicerie',
  surgeles: 'Surgelés',
  boissons: 'Boissons',
  hygiene: 'Hygiène',
  entretien: 'Entretien',
  bebe: 'Bébé',
  animaux: 'Animaux',
  autre: 'Autre',
};

export function nomRayon(rayon: Rayon | null): string {
  return rayon ? NOMS_RAYONS[rayon] : 'À ranger';
}
